module.exports = __webpack_public_path__ + "img/智驹-APP介绍-中文_2_05.6e04a580.jpg";